import { render } from "./invoiceDetails.vue?vue&type=template&id=e4ce29c4&scoped=true"
import script from "./invoiceDetails.vue?vue&type=script&lang=js"
export * from "./invoiceDetails.vue?vue&type=script&lang=js"

import "./invoiceDetails.vue?vue&type=style&index=0&id=e4ce29c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ce29c4"]])

export default __exports__